// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"antd-pro-components-common-table-col-attachment-styles-wrapper","rows":"antd-pro-components-common-table-col-attachment-styles-rows"};